export const zeroPadding = (num, digit) => {
  return (Array(digit + 1).join('0') + num).slice(-digit);
}
export const sleep = (delay) => {
  return new Promise(function(resolve) {
    setTimeout(resolve, delay);
  });
}

export const toggleFixedBody = (isFixed) => {
  if(isFixed) {
    const scrollY = window.scrollY;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
  } else {
    const scrollY = document.body.style.top;
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}

export default {
  zeroPadding
}
